// A list capped at 10 rows with one "Show all (N)" control (Session AFH; extracted from
// PortalSiteDetail so the site-detail history areas AND the two top-level history feed pages
// share one implementation). The Director's separate service / call-out areas stay scannable;
// nothing is hidden for good.
import { useState, type ReactNode } from "react";

export const HISTORY_DISPLAY_CAP = 10;

export function ShowAllList({ count, render }: { count: number; render: (cap: number) => ReactNode }) {
  const [showAll, setShowAll] = useState(false);
  const cap = showAll ? count : HISTORY_DISPLAY_CAP;
  return (
    <div>
      {render(cap)}
      {count > HISTORY_DISPLAY_CAP && !showAll && (
        <button
          type="button"
          onClick={() => setShowAll(true)}
          className="mt-2 min-h-11 w-full rounded-ele border border-white/10 px-4 py-2 font-menu text-xs tracking-wide text-ele-body transition hover:text-ele-white"
        >
          Show all ({count})
        </button>
      )}
    </div>
  );
}
